import { navItems, mainSiteUrl } from '@/mocks/navigation';
import { categories } from '@/mocks/categories';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="w-full bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 lg:px-10 py-12 md:py-16">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                  <i className="ri-file-excel-2-line"></i>
                </div>
                <span className="font-heading text-base text-foreground-900">
                  VigorBuy Guide
                </span>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                The complete resource hub for VigorBuy Spreadsheet users. Expert guides, reviews,
                tutorials, and more — all in one place.
              </p>
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
              >
                Visit Main Store
                <i className="ri-external-link-line text-xs"></i>
              </a>
            </div>

            <div>
              <h4 className="font-heading text-sm text-foreground-900 mb-4">Quick Links</h4>
              <div className="flex flex-col gap-2">
                {navItems.map((item) => (
                  item.href.startsWith('/') && !item.href.startsWith('/#') ? (
                    <Link
                      key={item.href}
                      to={item.href}
                      className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                    >
                      {item.label}
                    </Link>
                  ) : (
                    <a
                      key={item.href}
                      href={item.href}
                      className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                    >
                      {item.label}
                    </a>
                  )
                ))}
              </div>
            </div>

            <div>
              <h4 className="font-heading text-sm text-foreground-900 mb-4">Top Categories</h4>
              <div className="flex flex-col gap-2">
                {categories.slice(0, 7).map((cat) => (
                  <a
                    key={cat.name}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </a>
                ))}
              </div>
            </div>

            <div>
              <h4 className="font-heading text-sm text-foreground-900 mb-4">More Categories</h4>
              <div className="flex flex-col gap-2">
                {categories.slice(7).map((cat) => (
                  <a
                    key={cat.name}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </a>
                ))}
              </div>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} VigorBuy Spreadsheet Guide. All rights reserved.
              This is an independent informational resource.
            </p>
            <div className="flex items-center gap-4">
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="text-xs text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer"
              >
                VigorBuy Spreadsheet
              </a>
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="text-xs text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer"
              >
                Buy It Now
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}